interface ServiceItem {
  title: string;
  description: string;
  link: string;
  imageUrl: string;
  imageAlt: string;
}

export const SERVICES: ServiceItem[] = [
  {
    title: 'Dératisation',
    description: 'Rats et souris dans le galetas, la cuisine, le jardin.',
    link: '/deratisation-guadeloupe',
    imageUrl: '/images/deratisation-1.webp',
    imageAlt: 'Technicien dératiseur inspectant les traces de rats dans le galetas d\'une maison créole en Guadeloupe',
  },
  {
    title: 'Ravets & cafards',
    description: 'Traitement professionnel contre les ravets, y compris les gros ravets volants.',
    link: '/traitement-ravets-cafards-guadeloupe',
    imageUrl: '/images/ravets-cafards-1.webp',
    imageAlt: 'Traitement professionnel anti-ravets dans une cuisine traditionnelle en Guadeloupe',
  },
  {
    title: 'Termites',
    description: 'Curatif et préventif, la 2ᵉ cause de sinistre habitat aux Antilles.',
    link: '/traitement-termites-guadeloupe',
    imageUrl: '/images/termites-1.webp',
    imageAlt: 'Inspection des dégâts de termites sur une poutre de charpente ancienne en Guadeloupe',
  },
  {
    title: 'Punaises de lit',
    description: 'Éradication complète, discrétion garantie.',
    link: '/punaises-de-lit-guadeloupe',
    imageUrl: '/images/punaises-de-lit-1.webp',
    imageAlt: 'Traitement des punaises de lit dans une chambre en Guadeloupe',
  },
  {
    title: 'Scolopendres',
    description: "Empêcher les bêtes à mille pattes d'entrer chez vous.",
    link: '/scolopendres-guadeloupe',
    imageUrl: '/images/scolopendres-1.webp',
    imageAlt: 'Barrière de protection anti-scolopendres autour d\'une maison créole en Guadeloupe',
  },
  {
    title: 'Moustiques',
    description: 'Traitement des jardins et espaces extérieurs.',
    link: '/demoustication-guadeloupe',
    imageUrl: '/images/demoustication-1.webp',
    imageAlt: 'Traitement anti-moustiques par pulvérisation dans un jardin tropical en Guadeloupe',
  },
];

export interface BlogPostItem {
  title: string;
  excerpt: string;
  link: string;
  imageUrl: string;
  imageAlt: string;
}

export const BLOG_POSTS: BlogPostItem[] = [
  {
    title: 'Comment se débarrasser des ravets',
    excerpt: 'Les ravets envahissent votre cuisine ? Découvrez les méthodes efficaces pour les éliminer durablement sous le climat tropical de Guadeloupe.',
    link: '/blogue/se-debarrasser-des-ravets',
    imageUrl: '/images/blogue-se-debarrasser-des-ravets-1.webp',
    imageAlt: 'Cuisine créole propre et lumineuse avec produits anti-ravets en Guadeloupe',
  },
  {
    title: 'Morsure de scolopendre : que faire',
    excerpt: 'Vous avez été mordu par un scolopendre ? Voici les gestes à adopter immédiatement et quand consulter un médecin en Guadeloupe.',
    link: '/blogue/morsure-scolopendre-que-faire',
    imageUrl: '/images/blogue-morsure-scolopendre-que-faire-1.webp',
    imageAlt: 'Jardin tropical luxuriant avec végétation dense propice aux scolopendres en Guadeloupe',
  },
  {
    title: 'Rat dans la maison : que faire',
    excerpt: 'Vous entendez des bruits dans le galetas ? Apprenez à identifier une infestation de rats et les solutions pour protéger votre maison.',
    link: '/blogue/rat-dans-la-maison-que-faire',
    imageUrl: '/images/blogue-rat-dans-la-maison-que-faire-1.webp',
    imageAlt: 'Galetas en bois sous toiture en tôle avec traces d\'activité de rats en Guadeloupe',
  },
];

export const PRICING_TEASER = {
  deratisation: '75 €',
  ravets: '100 €',
  termites: 'Sur devis',
};

export const REASSURANCE_ITEMS = [
  {
    icon: 'ri-shield-check-line',
    text: 'Techniciens certifiés Certibiocide',
  },
  {
    icon: 'ri-price-tag-3-line',
    text: 'Prix ferme avant intervention',
  },
  {
    icon: 'ri-timer-flash-line',
    text: 'Intervention sous 24-48 h',
  },
  {
    icon: 'ri-whatsapp-line',
    text: 'Diagnostic photo WhatsApp en 2 h',
  },
];

export const HOW_IT_WORKS_STEPS = [
  {
    number: '1',
    icon: 'ri-camera-line',
    title: 'Vous nous montrez le problème.',
    description: 'Une photo sur WhatsApp ou un appel : on identifie le nuisible et on vous annonce un prix ferme sous 2 h.',
  },
  {
    number: '2',
    icon: 'ri-user-star-line',
    title: 'On intervient sous 24-48 h.',
    description: 'Un technicien certifié Certibiocide se déplace partout en Guadeloupe, avec des produits professionnels adaptés au climat tropical.',
  },
  {
    number: '3',
    icon: 'ri-shield-line',
    title: 'On fait en sorte que ça ne revienne pas.',
    description: 'Prévention, colmatage des accès, conseils concrets — et passage de contrôle si nécessaire.',
  },
];

export const WHY_GWADA_TEXT = "Parce qu'ici, les nuisibles ne connaissent pas l'hiver. Un traitement pensé pour la métropole ne tient pas face aux ravets de la saison des pluies, aux rats noirs qui grimpent dans les galetas ou aux termites qui attaquent une charpente en quelques mois. Nos techniciens travaillent avec des produits professionnels réservés aux détenteurs du Certibiocide et des méthodes adaptées au bâti antillais — cases créoles, toitures tôle, vides sanitaires. Le prix est annoncé avant l'intervention, et il ne bouge pas.";